import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['high-school-june-release'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
